import Decimal from 'decimal.js';
import html2canvas from 'html2canvas';
import $ from 'jquery';

$(() => {
  const singleProductWrapper = $('.single-product');
  if (!singleProductWrapper.length || typeof qtyAndPrice === 'undefined')
    return;

  let shippingQty = $(`.shipping-input`).val();
  let includeSetupChecked = $('.include-setup').prop('checked');
  let includeShippingChecked = $('.include-shipping').prop('checked');
  let beforeMarkupDecorationSetupTotal = 0;
  let beforeMarkupShippingCostTotal = 0;
  const minQty = qtyAndPrice[0].qty || 0;
  const wpApi = window.wp_api || {};

  $('.additional-cost-table').on('input', 'input', function () {
    enforceNonNegativeInteger(this);
    const selectedDecorationTableTr = $(this).closest('tr');
    const inputs = $(selectedDecorationTableTr).find('input');
    const decorationQty = Number(inputs.eq(0).val()) || 0;
    const decorationNewSetupQty = Number(inputs.eq(1).val()) || 0;
    const decorationRepeatSetupQty = Number(inputs.eq(2).val()) || 0;
    const totalSetupQty = decorationNewSetupQty + decorationRepeatSetupQty;
    if (totalSetupQty > decorationQty) {
      const currentInputIndex = inputs.index($(this));
      if (currentInputIndex === 0) {
        $(this).val(totalSetupQty);
      } else if (currentInputIndex === 1) {
        $(this).val(decorationQty - decorationRepeatSetupQty);
      } else if (currentInputIndex === 2) {
        $(this).val(decorationQty - decorationNewSetupQty);
      }
    }

    extractAdditionalDecorationTableTrData(selectedDecorationTableTr);
    calculateData();
  });

  $(`.shipping-input`).on('input', function () {
    enforceNonNegativeInteger(this);
    shippingQty = $(this).val();
    calculateData();
  });

  $('.price-table-before-markup').on('input', 'input', function () {
    enforceNonNegativeInteger(this);
    let value = Number($(this).val());
    let applyMoqSurcharge = false;
    const index = $(this).closest('td').index();
    if (moqAvailable) {
      applyMoqSurcharge = value < minQty;
      if (applyMoqSurcharge) {
        $('.price-table-before-markup tbody tr:eq(1) td:eq(' + index + ')')
          .removeClass('text-black')
          .addClass('text-red-600');
        $('.price-table-before-markup tbody tr:eq(2) td:eq(' + index + ')')
          .removeClass('text-black')
          .addClass('text-red-600');
        $('.price-table-after-markup tbody tr:eq(1) td:eq(' + index + ')')
          .removeClass('text-black')
          .addClass('text-red-600');
        $('.price-table-after-markup tbody tr:eq(2) td:eq(' + index + ')')
          .removeClass('text-black')
          .addClass('text-red-600');
      } else {
        $('.price-table-before-markup tbody tr:eq(1) td:eq(' + index + ')')
          .removeClass('text-red-600')
          .addClass('text-black');
        $('.price-table-before-markup tbody tr:eq(2) td:eq(' + index + ')')
          .removeClass('text-red-600')
          .addClass('text-black');
        $('.price-table-after-markup tbody tr:eq(1) td:eq(' + index + ')')
          .removeClass('text-red-600')
          .addClass('text-black');
        $('.price-table-after-markup tbody tr:eq(2) td:eq(' + index + ')')
          .removeClass('text-red-600')
          .addClass('text-black');
      }
      $(this).val(value || 0);
    } else {
      $(this).val(Math.max(value, minQty));
    }

    if (qtyAndPrice[index - 1]) {
      for (let i = 0; i < qtyAndPrice.length; i++) {
        if (i != qtyAndPrice.length - 1) {
          if (qtyAndPrice[i + 1].originalQty > Number($(this).val())) {
            qtyAndPrice[index - 1].price = qtyAndPrice[i].originalPrice;
            qtyAndPrice[index - 1].decorationPriceIndex = i + 1;
            break;
          }
        } else {
          qtyAndPrice[index - 1].price = qtyAndPrice[i].originalPrice;
          qtyAndPrice[index - 1].decorationPriceIndex = i + 1;
        }
      }
      qtyAndPrice[index - 1].qty = Number($(this).val());
      qtyAndPrice[index - 1].moqSurcharge = applyMoqSurcharge
        ? moqSurcharge
        : 0;
      $('.markup-table tbody tr:eq(0) td:eq(' + index + ')').text(
        $(this).val()
      );
      $('.price-table-after-markup tbody tr:eq(0) td:eq(' + index + ')').text(
        $(this).val()
      );
    }
    if (qtyAndPrice.some((item) => item.moqSurcharge !== 0 && item.qty > 0)) {
      $('.surcharge-notification').removeClass('hidden').addClass('block');
    } else {
      $('.surcharge-notification').removeClass('block').addClass('hidden');
    }

    calculateData();
  });

  $('.include-setup').on('change', function () {
    includeSetupChecked = $(this).prop('checked');
    const row = $('.markup-table tbody tr').eq(2);
    row.toggle(!includeSetupChecked);
    calculateData();
  });

  $('.include-shipping').on('change', function () {
    includeShippingChecked = $(this).prop('checked');
    const row = $('.markup-table tbody tr').eq(3);
    row.toggle(!includeShippingChecked);
    calculateData();
  });

  $('.markup-table').on('input', 'input', function () {
    enforceNonNegativeInteger(this);
    const trIndex = $(this).closest('tr').index();
    if (trIndex == 1) {
      const tdIndex = $(this).closest('td').index();
      if (markup['qty' + tdIndex] !== null) {
        markup['qty' + tdIndex] = parseInt($(this).val(), 10);
      }
    } else if (trIndex == 2) {
      markup.setupMarkup = parseInt($(this).val(), 10);
      generateAdditionalChargeTable();
    } else if (trIndex == 3) {
      markup.freightMarkup = parseInt($(this).val(), 10);
      generateAdditionalChargeTable();
    }
    calPriceAfterMarkup();
    changePriceTableAfterMarkup();
  });

  $('.set-default-markup').on('click', function () {
    const $button = $(this);
    $.ajax({
      type: 'POST',
      url: wpApi.root + 'wp/v2/users/me',
      data: {
        acf: {
          price_markup: JSON.stringify(markup),
        },
      },
      dataType: 'json',
      beforeSend: function (xhr) {
        $button.prop('disabled', true);
        xhr.setRequestHeader('X-WP-Nonce', wpApi.nonce);
      },
      success: function () {
        $button.text('Default Markups Saved!');
      },
      error: function (error) {
        console.error('Failed to update user meta', error);
      },
      complete: function () {
        setTimeout(() => {
          $button.prop('disabled', false).text('Set Default Markup %');
        }, 2000);
      },
    });
  });

  if (window.location.pathname.includes('product')) {
    calculateData();
  }

  function extractAdditionalDecorationTableTrData(tr) {
    const decorationName = $(tr)
      .find('td:first')
      .find('div:first div:first div:first')
      .text()
      .trim();
    const matchedDecoration = decorationData.find(
      (item) => decorationName === item.name
    );
    if (matchedDecoration) {
      matchedDecoration.qty =
        parseInt($(tr).find('input:eq(0)').val(), 10) || 0;
      matchedDecoration.newSetupQty =
        parseInt($(tr).find('input:eq(1)').val(), 10) || 0;
      matchedDecoration.repeatSetupQty =
        parseInt($(tr).find('input:eq(2)').val(), 10) || 0;
    }
    const addonName = $(tr).find('td:first').find('div:first').text().trim();
    const matchedAddon = addonData.find((item) => addonName === item.name);
    if (matchedAddon) {
      matchedAddon.qty = parseInt($(tr).find('input:eq(0)').val(), 10) || 0;
    }
  }

  function calPriceBeforeMarkup() {
    beforeMarkupDecorationSetupTotal = decorationData
      .reduce(
        (total, item) =>
          total
            .plus(new Decimal(item.newSetupQty || 0).times(item.newSetup || 0))
            .plus(
              new Decimal(item.repeatSetupQty || 0).times(item.repeatSetup || 0)
            ),
        new Decimal(0)
      )
      .toNumber();

    const addonTotal = addonData
      .reduce(
        (total, item) =>
          total.plus(new Decimal(item.price || 0).times(item.qty || 0)),
        new Decimal(0)
      )
      .toNumber();

    beforeMarkupShippingCostTotal = new Decimal(shippingQty || 0)
      .times(shippingCost || 0)
      .toNumber();
    qtyAndPrice.forEach((element) => {
      if (element.qty == 0) {
        element.subTotal = 0;
        element.unit = 0;
      } else {
        let moqSurchargeTotal = 0;
        if (element.moqSurcharge > 0) {
          if (decorationData.some((item) => item.qty > 0)) {
            moqSurchargeTotal = decorationData.reduce((total, item) => {
              if (item.qty == 0) {
                return total;
              } else {
                return total.plus(new Decimal(item.moqSurcharge));
              }
            }, new Decimal(0));
          } else {
            moqSurchargeTotal = element.moqSurcharge;
          }
          $('.surcharge-value').text(formatCurrency(moqSurchargeTotal));
        }
        const decorationUnitTotal = decorationData
          .reduce((total, item) => {
            return total.plus(
              new Decimal(item.qty || 0).times(
                new Decimal(item['price' + element.decorationPriceIndex] || 0)
              )
            );
          }, new Decimal(0))
          .toNumber();

        const baseTotal = new Decimal(element.price || 0)
          .plus(decorationUnitTotal)
          .plus(addonTotal)
          .times(element.qty || 0)
          .plus(moqSurchargeTotal)
          .toDecimalPlaces(2)
          .toNumber();

        if (includeSetupChecked && includeShippingChecked) {
          element.subTotal = new Decimal(baseTotal)
            .plus(beforeMarkupDecorationSetupTotal)
            .plus(beforeMarkupShippingCostTotal)
            .toNumber();
          element.unit = new Decimal(element.subTotal)
            .dividedBy(element.qty)
            .toDecimalPlaces(2)
            .toNumber();
        } else if (includeSetupChecked) {
          element.subTotal = new Decimal(baseTotal)
            .plus(beforeMarkupDecorationSetupTotal)
            .toNumber();
          element.unit = new Decimal(element.subTotal)
            .dividedBy(element.qty)
            .toDecimalPlaces(2)
            .toNumber();
        } else if (includeShippingChecked) {
          element.subTotal = new Decimal(baseTotal)
            .plus(beforeMarkupShippingCostTotal)
            .toNumber();
          element.unit = new Decimal(element.subTotal)
            .dividedBy(element.qty)
            .toDecimalPlaces(2)
            .toNumber();
        } else {
          element.subTotal = new Decimal(baseTotal).toNumber();
          element.unit = new Decimal(element.subTotal)
            .dividedBy(element.qty)
            .toDecimalPlaces(2)
            .toNumber();
        }
      }
    });
  }

  function changePriceTableBeforeMarkup() {
    const unitRow = $(`.price-table-before-markup`).find('tbody tr:eq(1)');
    const subTotalRow = $(`.price-table-before-markup`).find('tbody tr:eq(2)');

    const unitValues = qtyAndPrice.map((element) =>
      formatCurrency(element.unit)
    );
    const subTotalValues = qtyAndPrice.map((element) =>
      formatCurrency(element.subTotal)
    );
    clearAndFillRow(unitRow, unitValues);
    clearAndFillRow(subTotalRow, subTotalValues);

    if (!includeSetupChecked) {
      $(`.price-table-before-markup`).find('tbody tr:eq(3)').show();
      $(`.price-table-before-markup`)
        .find('tbody tr:eq(3) td:eq(1)')
        .text(formatCurrency(beforeMarkupDecorationSetupTotal));
    } else {
      $(`.price-table-before-markup`).find('tbody tr:eq(3)').hide();
      $(`.price-table-before-markup`).find('tbody tr:eq(3) td:eq(1)').text('');
    }
    if (!includeShippingChecked) {
      $(`.price-table-before-markup`).find('tbody tr:eq(4)').show();
      $(`.price-table-before-markup`)
        .find('tbody tr:eq(4) td:eq(1)')
        .text(formatCurrency(beforeMarkupShippingCostTotal));
    } else {
      $(`.price-table-before-markup`).find('tbody tr:eq(4)').hide();
      $(`.price-table-before-markup`).find('tbody tr:eq(4) td:eq(1)').text('');
    }
  }

  function calPriceAfterMarkup() {
    qtyAndPrice.forEach((element, index) => {
      if (element.qty == 0) {
        element.afterMarkupSubTotal = 0;
        element.afterMarkupUnit = 0;
      } else {
        element.afterMarkupUnit = new Decimal(element.unit)
          .times(1 + (markup['qty' + (index + 1)] || 0) / 100)
          .toDecimalPlaces(2)
          .toNumber();
        element.afterMarkupSubTotal = new Decimal(element.afterMarkupUnit)
          .times(element.qty)
          .toNumber();
      }
    });
  }

  function changePriceTableAfterMarkup() {
    const unitRow = $(`.price-table-after-markup`).find('tbody tr:eq(1)');
    const subTotalRow = $(`.price-table-after-markup`).find('tbody tr:eq(2)');

    const unitValues = qtyAndPrice.map((element) =>
      formatCurrency(element.afterMarkupUnit)
    );
    const subTotalValues = qtyAndPrice.map((element) =>
      formatCurrency(element.afterMarkupSubTotal)
    );
    clearAndFillRow(unitRow, unitValues);
    clearAndFillRow(subTotalRow, subTotalValues);
  }

  function generateAdditionalChargeTable() {
    const firstTr = $('.additional-charges-table tbody').find('tr:eq(0)');
    const lastTr = $('.additional-charges-table tbody').find('tr:last');
    let totalCharge = new Decimal(0);

    firstTr.nextUntil(lastTr).remove();
    const fragment = $(document.createDocumentFragment());
    decorationData
      .filter((item) => item.newSetupQty > 0 || item.repeatSetupQty > 0)
      .forEach((item) => {
        let setupCost = 'Included';
        if (!includeSetupChecked) {
          const afterMarkupDecorationSetupTotal = new Decimal(
            beforeMarkupDecorationSetupTotal
          )
            .times(1 + (markup.setupMarkup || 0) / 100)
            .toDecimalPlaces(2)
            .toNumber();
          totalCharge = totalCharge
            .plus(afterMarkupDecorationSetupTotal)
            .toNumber();
          setupCost = formatCurrency(afterMarkupDecorationSetupTotal);
        }
        const tr = $(`
          <tr class="font-normal">
            <td class="text-left p-2 border border-[#E9E9EB]">Setup/s - ${
              item.name
            }</td>
            <td class="p-2 border border-[#E9E9EB]">${
              item.newSetupQty + item.repeatSetupQty
            }</td>
            <td class="p-2 border border-[#E9E9EB]">${setupCost}</td>
          </tr>
        `);

        fragment.append(tr);
      });

    let shippingTotalCost = 'Included';
    if (!includeShippingChecked) {
      const afterMarkupShippingCostTotal = new Decimal(
        beforeMarkupShippingCostTotal
      )
        .times(1 + (markup.freightMarkup || 0) / 100)
        .toDecimalPlaces(2)
        .toNumber();
      totalCharge = new Decimal(totalCharge)
        .plus(afterMarkupShippingCostTotal)
        .toNumber();
      shippingTotalCost = formatCurrency(afterMarkupShippingCostTotal);
    }
    const tr = $(`
        <tr class="font-normal">
          <td class="text-left p-2 border border-[#E9E9EB]" colspan="2">Freight Charge For ${shippingQty} Location/s</td>
          <td class="p-2 border border-[#E9E9EB]">${shippingTotalCost}</td>
        </tr>
      `);

    fragment.append(tr);
    firstTr.after(fragment);
    lastTr
      .find('td:last')
      .text(totalCharge == 0 ? 'Included' : formatCurrency(totalCharge));
  }

  function calculateData() {
    calPriceBeforeMarkup();
    changePriceTableBeforeMarkup();
    calPriceAfterMarkup();
    changePriceTableAfterMarkup();
    generateAdditionalChargeTable();
  }

  function formatCurrency(value, currency = 'AUD', locale = 'en-AU') {
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: currency,
    }).format(value);
  }

  function enforceNonNegativeInteger(inputElement) {
    let value = $(inputElement).val();
    if (!/^\d*$/.test(value)) {
      value = value.replace(/\D/g, '');
    }
    $(inputElement).val(Math.max(0, parseInt(value) || 0));
  }

  function clearAndFillRow(row, values) {
    row.find('td').each(function (index) {
      if (index === 0) {
        return;
      }
      $(this).text(values[index - 1] || '');
    });
  }

  let overlayTimeout;
  $('.view-quote-button').on('click', function () {
    clonePriceAndChargeTable();
  });

  $('#view-quote-modal .update-btn').on('click', function () {
    const newNote = $('#view-quote-modal #note-input').val();
    $('#view-quote-modal .note').text(newNote);
  });

  $('#view-quote-modal .copy-button').on('click', function (e) {
    e.preventDefault();
    toggleQuoteOverlay(true);

    html2canvas(document.querySelector('#capture'), {
      useCORS: true,
      allowTaint: true,
    }).then((canvas) => {
      try {
        canvas.toBlob((blob) =>
          navigator.clipboard
            .write([
              new ClipboardItem({
                'image/png': blob,
              }),
            ])
            .then(() => {
              toggleQuoteOverlay(true, 'Copied Successfully');
              overlayTimeout = setTimeout(() => {
                toggleQuoteOverlay(false);
                overlayTimeout = null;
              }, 2000);
            })
            .catch((error) => {
              console.error(error);
              toggleQuoteOverlay(true, 'Copy Failed');
              overlayTimeout = setTimeout(() => {
                toggleQuoteOverlay(false);
                overlayTimeout = null;
              }, 2000);
            })
        );
      } catch (error) {
        console.error(error);
        toggleQuoteOverlay(true, 'Copy Failed');
        overlayTimeout = setTimeout(() => {
          toggleQuoteOverlay(false);
          overlayTimeout = null;
        }, 2000);
      }
    });
  });

  $('#view-quote-modal .download-button').on('click', async function (e) {
    e.preventDefault();
    toggleQuoteOverlay(true);

    try {
      const canvas = await html2canvas(document.querySelector('#capture'), {
        useCORS: true,
        allowTaint: true,
      });
      canvas.toBlob((blob) => {
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = 'QuickQuote.png';
        link.click();
        URL.revokeObjectURL(link.href);
      });
      toggleQuoteOverlay(true, 'Downloaded Successfully');
      overlayTimeout = setTimeout(() => {
        toggleQuoteOverlay(false);
        overlayTimeout = null;
      }, 2000);
    } catch (error) {
      console.error('Error generating canvas:', error);
      toggleQuoteOverlay(true, 'Download Failed');
      overlayTimeout = setTimeout(() => {
        toggleQuoteOverlay(false);
        overlayTimeout = null;
      }, 2000);
    }
  });

  function clonePriceAndChargeTable() {
    const currentIndex = $('.desktop-thumbnail')
      .find('img.border')
      .closest('.desktop-thumbnail')
      .index();
    const itemImg = $('#product-image-gallery-slider')
      .find('img')
      .eq(currentIndex)
      .clone();
    $('#view-quote-modal .quote-product-image').html(itemImg);

    $('#view-quote-modal .quote-price-table').empty();
    $('#view-quote-modal .quote-charge-table').empty();

    const originalTable = $('.price-table-after-markup');
    const priceTable = originalTable.clone();
    originalTable.find('tbody tr:eq(1)').each(function () {
      $(this)
        .find('td')
        .each(function (colIndex) {
          const $cell = $(this);
          if ($cell.text().trim() === '$0.00') {
            priceTable
              .find(
                `th:nth-child(${colIndex + 1}), td:nth-child(${colIndex + 1})`
              )
              .remove();
          }
        });
    });
    const chargeTable = $(`.additional-charges-table`).clone();
    $('#view-quote-modal .quote-price-table').append(priceTable);
    $('#view-quote-modal .quote-charge-table').append(chargeTable);
  }

  function toggleQuoteOverlay(show, message = '') {
    if (show) {
      $('#quote-overlay').removeClass('hidden').addClass('flex');
      if (message) {
        $('#quote-overlay .loading-icon')
          .removeClass('block')
          .addClass('hidden');
        $('#quote-overlay .quote-notification')
          .text(message)
          .removeClass('hidden');
      } else {
        $('#quote-overlay .loading-icon')
          .removeClass('hidden')
          .addClass('block');
      }
      if (overlayTimeout) {
        clearTimeout(overlayTimeout);
        overlayTimeout = null;
      }
    } else {
      $('#quote-overlay').removeClass('flex').addClass('hidden');
      $('#quote-overlay .quote-notification').addClass('hidden');
      $('#quote-overlay .loading-icon').addClass('hidden');
    }
  }
});
